module.exports = __webpack_public_path__ + "static/media/page07-bg.4b7e6344.png";